import { css } from "@emotion/react";
import { DateTime } from "luxon";
import { Link, useParams } from "react-router-dom";
import { useAccount } from "../store/account";
import { useShow } from "../store/show";

export default function HistoricalDataMessage() {
    const { accountID, showID } = useParams();
    const { data: account } = useAccount();
    const { data: show = {} } = useShow(accountID, showID);

    return account && account.offerUpgrade ? (
        <div
            css={css`
                margin: 1rem 0;
                padding: 0 1rem;
                background: #ffe18d;
                border: 2px solid #ffc82d;
                & > p {
                    margin: 1rem 0;
                }
            `}
        >
            {account.completeMeasurementUntil ? (
                <>
                    <p>The free Podtrac plan now includes 90 days of historical data.</p>
                    <p>
                        To obtain access to data for this show back to{" "}
                        {show.firstMeasuredDate &&
                            DateTime.fromISO(show.firstMeasuredDate, {
                                zone: "utc"
                            }).toLocaleString(DateTime.DATE_FULL)}{" "}
                        - the date when the show first began measuring with Podtrac -{" "}
                        <Link to={`/dashboard/${accountID}/upgrade`}>
                            upgrade to our <b>Grow Your Show</b> plan
                        </Link>
                        .
                    </p>
                </>
            ) : (
                <>
                    <p>Your free Podtrac plan includes 90 days of historical data.</p>
                    <p>
                        To get immediate access to data for this show back to{" "}
                        {show.firstMeasuredDate &&
                            DateTime.fromISO(show.firstMeasuredDate, {
                                zone: "utc"
                            }).toLocaleString(DateTime.DATE_FULL)}{" "}
                        - the date when the show first began measuring with Podtrac -{" "}
                        <Link to={`/dashboard/${accountID}/upgrade`}>
                            upgrade to our <b>Grow Your Show</b> plan
                        </Link>
                        .
                    </p>
                </>
            )}
        </div>
    ) : null;
}
